<template>
  <nav-bar title="" mode="light"></nav-bar>
  <div class="User-Agreement">
    <div class="content">
      <div class="top-title">HART Privacy Policy</div>

      <div class="small-title">Scope of this Privacy Policy</div>
      <p class="text">
        This privacy policy is applicable to how HART handles personally
        identifiable information that is left when you log in to the website and
        server, as well as other personally identifiable information shared with
        our business partners.
      </p>

      <div class="small-title">Account Information</div>
      <p class="text">
        You need to create a HART account to use our services.
      </p>

      <p class="text">
        If you choose to create a HART account, HART may ask you to provide your
        name (you can use your real name or an alias if you prefer), birthday,
        gender, hometown, biographical information, education background,
        occupation, profile picture, and email address so that we can identify
        you and provide you with better services. Some of this information is
        optional.
      </p>

      <p class="text">
        If you create a HART account by connecting with a third-party service,
        such as Facebook, Twitter, Google, YouTube, Instagram, VK, or Apple ID,
        or if you connect a HART account with a third-party account, we will use
        information from such third-party service, including your third-party
        service user name, gender, profile image, and birthday.
      </p>

      <p class="text">
        Certain information will be displayed publicly on your profile page,
        such as your user name, your age and who you are following. Your recent
        videos will also be displayed publicly on your profile page. We use your
        birthday to determine whether you have reached the minimum age to use
        our services. We use your background information (such as your hometown)
        to recommend content that may interest you and improve our services.
      </p>

      <p class="text">
        If you provide us with your phone number or email address, you agree
        that we may send text messages to that phone number, or email to that
        email address. We will do so only in compliance with applicable laws and
        regulations. If you deactivate our Services, you will no longer receive
        any text or email from us.
      </p>

      <div class="small-title">Address Book</div>
      <p class="text">
        You may choose to share with us your address book so that we can
        cross-reference with HART database.
      </p>

      <div class="small-title">Cookie</div>
      <p class="text">
        A cookie is a small piece of data that is stored on your computer or
        mobile device. Like many other websites and mobile applications, HART
        will set or access HART cookies on your computer or mobile device.
      </p>

      <div class="small-title">Location</div>
      <p class="text">
        We require your location information, such as your IP address, in order
        to set up and maintain connection and provide Services to you. If your
        privacy settings allow, we will make recommendations using on your
        location information.
      </p>

      <div class="small-title">History and Data Storage</div>
      <p class="text">
        We will keep record of your interests, such as your viewing history, to
        recommend contents that may interest you. We will also keep record of
        the virtual gift you send or receive on HART for the gift system to
        function.
      </p>

      <p class="text">
        Any data we collected from you may be stored no longer than 15 days or
        other duration as we deem appropriate for rendering our service to you.
      </p>

      <div class="small-title">Device Information</div>
      <p class="text">
        HART automatically receives and records additional information about
        your device, such as device model. We will use such information to
        detect abnormal activities and prevent security breach. We will also use
        such information to identify a banned account or device.
      </p>

      <div class="small-title">Bank Information</div>
      <p class="text">
        We require your bank information and other sensitive information in
        order to make payment to you. You shall be solely responsible for the
        accuracy of such information in order for us to process the payment.
      </p>

      <div class="small-title">Information Shared by You</div>
      <p class="text">
        Most communications on HART are public and some may be immediately
        viewed by others. Therefore, you should think twice before sharing any
        sensitive information.
      </p>

      <p class="text">
        Our staff carefully reviews and moderate/monitor content posted in group
        messages and private messages 24 hours a day, 7 days a week to determine
        whether there's a violation of any Community Guidelines including but
        not limited to fake engagement, impersonation, links in content, child
        safety, nudity and sexual content, harassment and cyber bullying,
        content that features firearms, harmful or dangerous content, hate
        speech, violent criminal organization, sale of illegal or regulated
        goods or any spam, deceptive practices and scams or any other related
        matter.
      </p>

      <p class="text">
        Your group messages and private messages may also be monitored by us to
        prevent illegal activities. Your group messages and private messages
        (including any image or video contained) may be shared with law
        enforcement agencies if we are requested to do so.
      </p>

      <div class="small-title">Children Protection</div>
      <p class="text">
        HART is not directed to children, and if you are under the minimum age
        as specified in HART User Agreement, you may not create a HART account
        or use HART services.
      </p>

      <p class="text">
        HART has zero tolerance to any form of child abuse or exploitation. Your
        data (including group messages and private messages) may be shared with
        law enforcement agencies if we have reasonable grounds to believe that
        you have engaged in child pornography, or if we are requested to do so
        by law enforcement agencies.
      </p>

      <p class="text">How to delete your personal information</p>

      <p class="text">
        We promise we don't collect any personal data and information or share
        your data to anyone. If you want to delete your personal information,
        please try the following step. First, click Me, click settings, click
        feedback and input the messages about deleting the information. Second,
        send emails to <span class="email">hartliveteam@gmail.com</span>
        attached your HART id. We will delete your data.
      </p>

      <div class="small-title">Global Operation</div>
      <p class="text">
        In order to provide Services to our users all over the world, we operate
        globally. You hereby authorize us to transfer, store, and use your data
        in any country and region we operate, including Singapore, the People
        Republic of China and the European Union. In doing so we shall ensure
        the security of your data.
      </p>

      <div class="small-title">How to Manage Your Personal Information</div>
      <p class="text">
        The privacy settings allow you to control whether or not to share
        certain information and whether you may be found by certain HART
        function.
      </p>

      <p class="text">
        You may modify your account information on your profile page.
      </p>

      <p class="text">
        If you believe the personal information we have about you is inaccurate,
        you may also email us to update such inaccurate information.
      </p>

      <p class="text">
        You may also deactivate your account by emailing to us. Once your
        account is deactivated, you will not be able to restore your account
        again.
      </p>

      <p class="text">
        Please note that third parties may still retain copies of your
        information even after your account is deactivated.
      </p>

      <p class="text">
        If your account is deactivated due to your violation of our Terms of
        Use, we may retain certain information (such as device information,
        phone number) to prevent you from accessing our Services again.
      </p>

      <div class="small-title">Disclosure</div>
      <p class="text">
        I. The protection of user privacy is a fundamental policy of HART. HART
        guarantees that it will not publicly disclose or provide a third party
        with your non-public information, unless in the following circumstances
        as follows:
      </p>

      <p class="text">
        a) When prior express authorization is obtained from you;
      </p>

      <p class="text">
        b) When and as required by prevailing laws and/or regulations;
      </p>

      <p class="text">
        c) When and as required by relevant competent authorities of the
        government;
      </p>

      <p class="text">
        d) When it is necessary to safeguard the public interest;
      </p>

      <p class="text">
        e) When it is necessary to protect the safety of any person (including
        you);
      </p>

      <p class="text">
        f) When it is necessary to address fraud, security or technical issues;
      </p>

      <p class="text">
        g) When it is necessary to safeguard the legal rights and interests of
        HART.
      </p>

      <p class="text">
        II. HART may collaborate with a third party (an affiliate or otherwise)
        to provide you with relevant Services. In this scenario, HART has the
        right to share your information with a third party, if the third party
        agrees to bear responsibility for providing privacy protection no less
        favorable to that of HART.
      </p>

      <p class="text">
        III. Under the condition that no private information of an individual
        user is disclosed, HART has the right to analyze the entire user
        database and utilize the database for commercial purposes.
      </p>

      <div class="small-title">Contact Information</div>
      <p class="text">
        You may reach us via the following email address: <span class="email"
        >hartliveteam@gmail.com</span>
      </p>

      <div class="small-title">Law Enforcement</div>
      <p class="text">
        HART is willing to cooperate with law enforcement agencies to combat
        crimes.
      </p>

      <p class="text">
        Due to security concerns, we are unable to accept requests for
        non-public user information that are served via email. Except for
        exigent emergency involving imminent danger to life, original document
        of the formal request (subpoena, search warrant, court order or other
        legal proceedings) and any supporting document (such as scan copy of
        identification card or police badges) must be served to the office
        address of HART Technology Pte. Ltd. (as indicated above) before the
        user information is released to the law enforcement agencies. We
        encourage law enforcement agencies to notarize the formal request to
        help us verify its authenticity. We will not release sensitive user
        information unless we are convinced of the authenticity of the request.
      </p>

      <p class="text">
        The formal request should: (a) identify the HART ID or UID of requested
        account, (b) identify the information requested, (c) indicate the
        purpose of the request or indicate that the purpose is confidential; and
        (d) state the legal basis for the request. If the formal request is not
        in English, we encourage the law enforcement agencies to provide an
        English translation.
      </p>

      <p class="text">
        We will keep the existence of the request confidential if requested by
        the law enforcement agencies. However, we may take actions against any
        account that violates the User Agreement, including disabling the
        account.
      </p>

      <p class="text">
        We encourage law enforcement agencies to contact us via email (<span
          class="email"
        >hartliveteam@gmail.com</span>) regarding the availability of user
        information before serving the formal request.
      </p>

      <div class="small-title">Amendments to the Privacy Policy</div>
      <p class="text">
        HART periodically makes changes to the privacy policy. And the current
        version will be found at the following link: About us>Privacy Policy .
        By continuing to avail our Services, you agree to be bound by the
        revised Privacy Policy.
      </p>

      <div class="small-title">App Tracking Transparency</div>
      <p class="text">
        We want to request user authorization to access app-related data for
        tracking the user or the device. We use the AppTracking Transparency
        framework and it's possible to collect and share some user data with
        other companies such as unity, IronSource, Facebook and so on.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavBar from '@/components/navBar/NavBar.vue'
</script>

<style scoped lang="scss">
.User-Agreement {
  width: 100%;
  height: 100%;
  padding: 153px 30px 0;

  .content {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  .top-title {
    width: 100%;
    height: 40px;
    margin: 30px 0;
    font-size: 36px;
    font-weight: bold;
    line-height: 40px;
    color: #fff;
    text-align: center;
  }

  .small-title {
    width: 100%;
    height: 40px;
    margin: 30px 0;
    font-size: 30px;
    font-weight: bold;
    line-height: 40px;
    color: #fff;
  }

  .text {
    width: 100%;
    margin: 30px 0 0;
    font-size: 24px;
    line-height: 40px;
    color: #ffedbc;

    .email {
      color: red;
    }
  }
}
</style>
